import React, { Suspense } from 'react'
import { Switch, Route } from 'react-router-dom'
import { GuardedRoute } from 'react-router-guards'

type RouteFactoryProps = {
  routes: {
    layout: any
    pages: {
      path: string
      component: any
      meta?: any
      exact?: boolean
    }[]
  }[]
}

const Loading = () => (
  <div></div>
)

export const RouteFactory:React.FC<RouteFactoryProps> = ({ routes }: RouteFactoryProps) => {
  return (
    <Switch>
      {routes.map(({ layout: Layout, pages }, index) => (
        <Route key={index} path = {pages.map(page => page.path)}>
          <Layout>
            <Suspense fallback={<Loading/>}>
              <Switch>
                {pages.map(({ path, component, ...page }, idx) => (
                  <GuardedRoute
                    key={`${index}-${idx}`}
                    path={path}
                    component={component}
                    {...page}
                    exact={page.exact || true}
                  />
                ))}
              </Switch>
            </Suspense>
          </Layout>
        </Route>
      ))}
    </Switch>
  )
}
